"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * [[SignalingClientConnectionRequest]] represents an connection request.
 */

var SignalingClientConnectionRequest = /*#__PURE__*/function () {
  /** Creates a request with the given URL, conference id, and join token.
   *
   * @param signalingURL The URL of the signaling proxy.
   * @param joinToken The join token that will authenticate the connection.
   */
  function SignalingClientConnectionRequest(signalingURL, joinToken) {
    _classCallCheck(this, SignalingClientConnectionRequest);

    this.signalingURL = signalingURL;
    this.joinToken = joinToken;
  }
  /** Gets the signaling URL representing this request.*/


  _createClass(SignalingClientConnectionRequest, [{
    key: "url",
    value: function url() {
      return this.signalingURL + '?X-Chime-Control-Protocol-Version=3&X-Amzn-Chime-Send-Close-On-Error=1';
    }
    /** Gets the protocols associated with this request.*/

  }, {
    key: "protocols",
    value: function protocols() {
      return ['_aws_wt_session', this.joinToken];
    }
  }]);

  return SignalingClientConnectionRequest;
}();

exports.default = SignalingClientConnectionRequest;